module.exports = __webpack_public_path__ + "img/Moon Colony Bloodbath.0993072a.jpg";